// extracted by mini-css-extract-plugin
export default {"wrapper":"alternativeSpanish_wrapper__GwCJp","button":"alternativeSpanish_button__06i8h"};